module.exports = __webpack_public_path__ + "static/media/feat-chapter-hero.0f928efe.jpg";